import PropTypes from "prop-types";
import MediaLogo from "./MediaLogo";
import { MediaVideoPlayer } from "./MediaVideoPlayer";
import { GSAPAnimationMediaVideo } from "components/GSAP";
import { getAspectRatio } from "utils";

export default function MediaVideo({
  id,
  imageVideo,
  imageVideoMobile,
  videoMode,
  logo,
  size,
  marginBottom,
  hideVideoControls,
  backgroundColor,
  lang,
}) {
  const getMarginBottomHeight = (marginBottom) => {
    switch (marginBottom) {
      case "margin__bottom__0":
        return "0";
      case "margin__bottom__80":
        return "5rem";
      case "margin__bottom__160":
        return "10rem";
      case "margin__bottom__240":
        return "15rem";
      default:
        return "0";
    }
  };

  return (
    <div
      className={`geco-media_video ${
        size === "default" ? "globalComponentContainer" : ""
      } ${size === "full_screen" ? "geco-media_video-full" : ""}`}
    >
      {backgroundColor !== "transparent" && size === "full_screen" && (
        <GSAPAnimationMediaVideo
          id={id}
          marginBottom={marginBottom}
          onScreenAnimation="scaleBorder"
        >
          <div
            className="border-div top-border"
            style={{ height: getMarginBottomHeight() }}
          />
          <div
            className="border-div bottom-border"
            style={{ height: getMarginBottomHeight() }}
          />
          <div className="border-div left-border" />
          <div className="border-div right-border" />
        </GSAPAnimationMediaVideo>
      )}
      {logo.id && (
        <GSAPAnimationMediaVideo onScreenAnimation="logo" id={logo.id}>
          <MediaLogo
            id={logo.id}
            name={logo.name}
            logo_width={logo.width}
            logo_height={logo.height}
          />
        </GSAPAnimationMediaVideo>
      )}

      <MediaVideoPlayer
        id={id}
        lang={lang}
        video={imageVideo.url ? imageVideo.url : ""}
        videoMobile={
          imageVideoMobile.url ? imageVideoMobile.url : imageVideo.url
        }
        hideControls={hideVideoControls}
        showPlay={!(videoMode === "click_to_play" || logo.url !== "")}
        showCustomPlayButton={videoMode === "click_to_play"}
        showBigPlayButton={!!(videoMode !== "click_to_play" || logo.id)}
        aspectRatio={getAspectRatio(
          imageVideo.width,
          imageVideo.height,
          "Video"
        )}
        useAspectRatio={size !== "full_screen"}
        poster={imageVideoMobile.poster}
        videoInfo={imageVideo}
        videoInfoMobile={imageVideoMobile}
        videoInfo4K={imageVideo}
      />
    </div>
  );
}

MediaVideo.propTypes = {
  id: PropTypes.string,
  lang: PropTypes.string,
  imageVideo: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    url: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
    type: PropTypes.string,
  }),
  imageVideoMobile: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    url: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
    type: PropTypes.string,
  }),
  videoMode: PropTypes.oneOf(["autoplay_muted", "click_to_play"]).isRequired,
  videoUrl: PropTypes.string,
  logo: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    url: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
    type: PropTypes.string,
  }),
  size: PropTypes.oneOf(["default", "full_width", "full_screen"]),
  hideVideoControls: PropTypes.bool.isRequired,
  marginBottom: PropTypes.oneOf([
    "margin__bottom__0",
    "margin__bottom__80",
    "margin__bottom__160",
    "margin__bottom__240",
  ]).isRequired,
  backgroundColor: PropTypes.string,
};
